export default __webpack_public_path__ + "static/media/Racializedpeople_fr.7bb995f3.svg";